import React from "react";
import "./TermsOfUse.css";
import DefaultLayout from "../../layouts/DefaultLayout";

const Security = () => {
  return (
    <>
      <DefaultLayout>
        <div>
          <div className="termsofuse-container">
            <div className="termsofuse-section">
              <div className="termsofuse-header">
                <h5 className="termsofuse-h5">SECURITY</h5>
              </div>

              <div className="document-section">
                <div className="termsofuse-document">
                  <h5 className="document-heading">
                  How safe is my money?
                  </h5>
                  <p className="effective-document-p">
                  Security of your savings and investment is a priority for OVest. You can be rest assured 
                  that your money is kept safe and secure with multiple layers of protection.
                  </p>
                </div>
                <div className="termsofuse-document">
                  <h5 className="document-heading security-center-text">
                  Your money is well protected
                  </h5>
                </div>


                <div>
                  <h5 className="effective-document-h5">Best-In-Class Investments</h5>
                  <p className="effective-document-p">
                  OVest team of experienced finance professionals invest in risk-free investment 
                  portfolios which include treasury bills, government bonds, and professionally 
                  managed mutual funds.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">Bank-Grade Security</h5>
                  <p className="effective-document-p">
                  OVest Payment processors are PCI-DSS compliant to ensure optimum security of your data electronically.
                   All card and bank data are encrypted to prevent unauthorized access to sensitive information.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">Two-Factor Authentication (2FA)</h5>
                  <p className="effective-document-p">
                  2FA is an extra layer of protection to ensure the security of your account beyond just a username and password. 
                  All verifications for key transactions pass through the the 2FA process on OVest.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">Asset Under Secure Watch</h5>
                  <p className="effective-document-p">
                  In addition to investing your savings in low risk financial instruments,
                   these instruments are held on behalf of our customers by Meristem Trustees, registered 
                   with The Securities and Exchange 
                   Commission (SEC).
                  </p>
                </div>

                <div className="termsofuse-document">
                  <h5 className="document-heading">
                  <div className="termsofuse-document">
                  <h5 className="document-heading security-center-text">
                  Top security questions
                  </h5>
                </div>
                  </h5>
                </div>

                <div>
                  <h5 className="effective-document-h5">Where is OVest's office located?</h5>
                  <p className="effective-document-p">
                  Our office is located at 5C1, Majaro Street, Ajibade Bus-stop, Mokola, Ibadan.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">How safe are my debit card details with OVest?</h5>
                  <p className="effective-document-p">
                  OVest payment processors are PCI DSS compliant to ensure all 
                  delicate data are encrypted and rendered unreadable.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  Is OVest regulated by the CBN or protected by the NDIC?
                  </h5>
                  <p className="effective-document-p">
                  OVest is not a bank but an investment company. We work with Meristem trustees regulated by the 
                  Securities and Exchange Commission (SEC) to ensure we take the right decisions with your investment.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  Who is Meristem?
                  </h5>
                  <p className="effective-document-p">
                  Meristem Securities Limited is a Capital Market Conglomerate
                   regulated by the Securities and Exchange Commission (SEC) of which Meristem Trustees is a subsidiary.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  Who will be held responsible for my funds with OVest?
                  </h5>
                  <p className="effective-document-p">
                  At OVest, you are your first personal financial manager. We provide all the tools necessary for you to take charge of your finances. However, our team of financial 
                  experts led by a CFA charter holder takes away the hassle that comes with choice of investment portfolios.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  Why does OVest require my debit card details?
                  </h5>
                  <p className="effective-document-p">
                  All automated transactions are done using your debit card, as we take away the hassle that comes with banking 
                  halls. Payments for savings and investments are made via your bank issued debit card, secure and seamless.
                  </p>
                </div>

                <div>
                  <h5 className="effective-document-h5">
                  How does OVest offer higher interests?
                  </h5>
                  <p className="effective-document-p">
                  Your saved funds are securely invested on your behalf for the duration you choose. 
                  Our investment portfolio is a mix of high quality and low-risk financial instruments issued by both Central Bank of Nigeria and the Debt Management Office (DMO). The interest you earn is earned from the returns on these investments.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};

export default Security;
